import { get, globalPut } from "../index";

// Archive a project (out of the personal area's main list, onto its
// Archived page, for every member) or restore it. Same gate as editing
// the project. Nothing else about the project changes.
export const setProjectArchived = (projectId, archived) =>
  globalPut(`/projects/${projectId}/archive`, { archived }, false);

// The archived projects the signed-in user is a member of, in the same
// shape as the main list.
export const getArchivedProjects = () => get("/projects?archived=1");
